import { Severity } from 'Data/ViewModels/Core/types';
import classNames from 'classnames';
import React, { useState } from 'react';
import { FormattedText } from '../FormattedText';
import { withInjectedProps } from '../InjectedPropsContext';
import './TextOutput.scss';

export interface ITextOutputProps {
  blankReplacement?: string;
  format?: any;
  /**
   * Truncates text output to a single line (with an ellipsis)
   * Used to avoid overflow in layouts that do not support it
   */
  truncate?: boolean;
  inline?: boolean;
  severity?: Severity;
  value?: any;
  visible?: boolean;
  comparisonSymbol?: string;
}

const TextOutputBase: React.FC<ITextOutputProps> = ({
  blankReplacement = '-',
  format,
  truncate = false,
  inline = false,
  severity,
  value,
  visible = true,
  comparisonSymbol,
}) => {
  const [hasValue, setHasValue] = useState(false);

  const classnames = classNames('TextOutput', {
    'TextOutput-blank': !hasValue,
    'TextOutput-truncate': truncate,
    'TextOutput-inline': inline,
    [`TextOutput-${severity}`]: !!severity,
  });

  return !visible ? null : (
    <div className={classnames}>
      <FormattedText
        format={format}
        value={value}
        comparisonSymbol={comparisonSymbol}
        hasValueCallback={setHasValue}
        blankReplacement={blankReplacement}
      />
    </div>
  );
};

const TextOutput = withInjectedProps(TextOutputBase);

export { TextOutput, TextOutputBase };
export default TextOutput;
